import { InjectionToken } from '@angular/core';
import { PortalType } from '@ats/api/cm';

export interface ClientServiceConfig {
	portal: PortalType;
}

export const CLIENT_SERVICE_CONFIG = new InjectionToken<ClientServiceConfig>(
	'Client Service Configuration'
);

export interface UserpilotConfig {
	token: string;
	debug: boolean;
}

export interface ClientConfig {
	pageSizeOptions: number[];
	pageSize: number;
	disableEmailSignatureLogo: boolean;
	initialViewState: 'table' | 'grid';
	candidateSearch: {
		options: string[];
		selected: string;
	};
	url: {
		cpHelpDeskUrl: string;
	};
	userpilot: {
		local: UserpilotConfig,
		beta: UserpilotConfig,
		production: UserpilotConfig,
	};
}

export const DEFAULT_CLIENT_CONFIG: ClientConfig = {
	pageSizeOptions: [25, 50, 100],
	pageSize: 25,
	disableEmailSignatureLogo: false,
	initialViewState: 'grid',
	candidateSearch: {
		options: [],
		selected: 'externalId',
	},
	url: {
		cpHelpDeskUrl: '',
	},
	userpilot: {
		local: {
			token: '',
			debug: false
		},
		beta: {
			token :'',
			debug: false
		},
		production: {
			token :'',
			debug: false
		},
	}
};

export interface ClientTheme {
	name: string;
	logo: string;
	logoKO: string;
	logoEmail: string;
}
